import { Component, Input, ViewChild,TemplateRef } from '@angular/core';
import { CetOutsourcingComponent } from './cet-outsourcing/cet-outsourcing.component';
import { ActivatedRoute, Router } from '@angular/router';
import { EventViewModel } from '../../models-views/event.view.model';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { EventModel } from '../../models/event.model';
import { QuickAddService } from '../../services/quick-add.service';
import { ConsoleTabService } from '../../services/console-tab.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CetTasksComponent } from './cet-tasks/cet-tasks.component';
import { CetQuotationsComponent } from './cet-quotations/cet-quotations.component';
import { CetInvoicesComponent } from './cet-invoices/cet-invoices.component';
import { CetNotesComponent } from './cet-notes/cet-notes.component';
import { CetInquiryComponent } from './cet-inquiry/cet-inquiry.component';
import { AdvancedPaymentsComponent } from './advanced-payments/advanced-payments.component';

import { TitleService } from '../../services/title.service';
import { CetComplianceSafetyComponent } from './cet-compliance-safety/cet-compliance-safety.component';
import { GenerateEventPdfComponent } from './generate-event-pdf/generate-event-pdf.component';
import { skip, take } from 'rxjs/operators'; // Make sure to import these operators
import { CetSourcingNeedsV2Component } from './cet-sourcing-needs-v2/cet-sourcing-needs-v2.component';
@Component({
  selector: 'app-console-event-tab',
  standalone: false,
  templateUrl: './console-event-tab.component.html',
  styleUrl: './console-event-tab.component.scss'
})
export class ConsoleEventTabComponent {
  @Input() tabData: any;
  event: any

  loading: boolean = true
  tabList: any[] = [
    { id: 0, name: "Dashboard", icon: 'dashboard' ,disabled:false},
    { id: 1, name: "Tasks", icon: 'file-done',disabled:false },
    { id: 2, name: 'Sourcing Needs', icon: 'carry-out',disabled:false },
    { id: 3, name: 'Compliance', icon: 'safety',disabled:false },

    // { id: 2, name: "Pending tasks", icon: 'loading-3-quarters',disabled:false },
    { id: 4, name: "Outsourcing", icon: 'shop',disabled:false },
    { id: 5, name: "Requests", icon: 'container' ,disabled:false },
    { id: 6, name: "RFQ", icon: 'solution' ,disabled:false },
    { id: 7, name: "Quotations", icon: 'file-text' ,disabled:false},
    { id: 8, name: "Bills", icon: 'file-protect',disabled:false },
    { id: 9, name: "Payments", icon: 'money-collect' ,disabled:false},
    { id: 10, name: 'Notes & Review', icon: 'snippets',disabled:false },
    // { id: 8, name: 'Compliance & Safety', icon: 'safety',disabled:false }
    // { id: 8, name: 'Notes', icon: 'snippets',disabled:false }


  ];
  selectedTabIndex: number = 0;
  panelActive = false;
  eventModel = new BehaviorSubject<EventModel>(new EventModel())
  // @ViewChild(CetOutsourcingComponent) childComponent!: CetOutsourcingComponent;
  isConsolePage: boolean = false;
  destroy$ = new Subject()

  // @ViewChild('cetTaskPending') cetTaskPending?: CetTasksComponent;
  @ViewChild('cetTaskAll') cetTaskAll?: CetTasksComponent;
  @ViewChild('cetOutsourcing') cetOutsourcing?: CetOutsourcingComponent;
  @ViewChild('cetInquiry') cetInquiry?: CetInquiryComponent;
  @ViewChild('vendorTequests') vendorTequests?: CetOutsourcingComponent;
  @ViewChild('cetQuotations') cetQuotations?: CetQuotationsComponent;
  @ViewChild('cetInvoices') cetInvoices?: CetInvoicesComponent;
  // @ViewChild('cetPayments') cetPayments?: CetPaymentsComponent;
  @ViewChild('addvancePayments') addvancePayments?: AdvancedPaymentsComponent;
  @ViewChild('cetNotes') cetNotes?: CetNotesComponent;
  @ViewChild('cetComplianceSafety') cetComplianceSafety ?: CetComplianceSafetyComponent
  @ViewChild('cetSourcingNeeds') cetSourcingNeeds ?: CetSourcingNeedsV2Component



eventDates =  [
        {
            event_date: '2025-10-23T00:00:00Z', // Date part
            start_time: '2025-10-23T10:00:00Z', // Time part (date doesn't matter, just time)
            end_time: '2025-10-23T12:00:00Z',
            duration: 'Half Day'
        },
        {
            event_date: '2025-10-24T00:00:00Z',
            start_time: '2025-10-24T10:00:00Z',
            end_time: '2025-10-24T12:00:00Z',
            duration: 'Half Day'
        },
        {
            event_date: '2025-10-25T00:00:00Z',
            start_time: '2025-10-25T09:00:00Z',
            end_time: '2025-10-25T17:00:00Z',
            duration: 'Full Day'
        }
    ]



  constructor(private vm: EventViewModel, private route: ActivatedRoute, private quickAddService: QuickAddService,private titleService: TitleService,
    private router: Router, private consoleTabService: ConsoleTabService, private modal: NzModalService, private activeRouter: ActivatedRoute) {
    this.vm.consoleEventTabComponent = this
    this.vm.subscribeToEventDetail(this.eventModel);

    this.quickAddService.refreshData.pipe(takeUntil(this.destroy$)).subscribe(data => {
         if (data) {
              this.vm.getEventById(this.tabData.id, 1, 1)
         }
       })
  }

  ngOnInit(): void {

    if (this.router.url.includes('/app/console')) {
      this.isConsolePage = true;
    } else{
      this.titleService.setTitle('Events Details');
    }

    if (this.router.url.includes('/app/events')) {
      const pageID = Number(this.activeRouter.snapshot.paramMap.get('id'));
      this.tabData = { id: pageID, name: `events-details-${pageID}` }
    }


    this.vm.getEventById(this.tabData.id, 1, 1)

  }

   ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  goToClient(id: number){
    let li = '/app/clients/' + id
    window.open(li, '_blank');
  }

  goToProject(id: number){
    let li = '/app/projects/'+ id
    window.open(li, '_blank');
  }

  clientDataReceived() {
    this.loading = false
  }


  clientDataReceivedError() {
    this.loading = false;

    if (!this.tabData.name.startsWith('events-details')) {
      // this.router.navigate(['/app/clients'])
      this.modal.confirm({
        nzTitle: 'The event is not available or deleted.',
        nzContent: '<b style="color: red;">Do you want to remove it?</b>',
        nzOkText: 'Yes',
        nzOkType: 'primary',
        nzOkDanger: true,
        nzOnOk: () => this.consoleTabService.removeConsoleTabById(this.tabData.id),
        nzCancelText: 'No',
        nzOnCancel: () => console.log('Cancel')
      });
    }

  }

  get eventMonth(): number {
    return new Date(this.event?.event_datetime).getMonth();
  }

  get currentMonth(): number {
    return new Date().getMonth();
  }

  get eventDate(): number {
    // console.log(new Date(this.event?.event_datetime).getDate())
    return new Date(this.event?.event_datetime).getDate();
  }

  get currentDate(): number {
    // console.log(new Date().getDate())
    return new Date().getDate();
  }

  eventdataRecieved() {
    this.loading = false
    this.event = this.eventModel.value;

    // console.log("recived event data ::",this.event)
    // if(this.eventModel.value){
    //  this.tabList =  this.tabList.filter(e =>  'id' in this.event.project_details ? e.name.includes('') : !e.name.includes('task')  )
    // }
    if(this.eventModel.value){
     this.tabList =  this.tabList.map(e =>  ({
      ...e,
      disabled : (!('id' in this.event.project_details) && e.name.includes('task'))
     })  )
    }

    // Build eventDays table data from timing array if available

    if (Array.isArray(this.event?.timing) && this.event.timing.length > 0) {
      this.eventDates = this.event.timing
        .filter((t: any) => t?.start_time && t?.end_time)
        .map((t: any) => {
          const startIso = this.toIsoUtc(t.start_time);
          const endIso = this.toIsoUtc(t.end_time);
          const eventDateIso = this.toMidnightIsoUtcFromIsoString(startIso);
          const dayTypeRaw = (t.day_type || '').toString().toLowerCase();
          const rowDuration = dayTypeRaw === 'roundtable'
            ? 'Roundtable'
            : (dayTypeRaw === 'half' ? 'Half Day' : 'Full Day');
          return {
            event_date: eventDateIso,
            start_time: startIso,
            end_time: endIso,
            duration: rowDuration
          };
        });
    } else {
      this.eventDates = [];
    }

  }

  getBase64Image(data: string){
    if(!data){
      return undefined;
    }
    return "data:image/png;base64," + data;
  }

  getStartDays(d: string) {
    if (d != undefined) {


      const eventDate = new Date(d).getTime();
      const now = new Date().getTime();


      const diffInMs = Math.abs(now - eventDate); // difference in milliseconds
      const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24)); // convert to days

      return diffInDays

    } else {
      return 0
    }


  }

  editEvent(data: any) {
    // console.log("-------------------",data)
    this.quickAddService.openQuickUpdate('event', data)
  }

  deleteEvent(event: any) {
    this.vm.deleteEvent(event.id);
  }

  eventDeleted(){
    if (this.tabData.name.startsWith('events-details') || this.router.url.includes('/app/events')) {
      this.router.navigate(['/app/events/all'])
    } else {
      this.consoleTabService.removeConsoleTabById(this.tabData.id);
    }
  }


  trackByFn(index: number, tab: any) {
    return tab.id;
  }

  onTabChange(e: any) {

    setTimeout(() => {
      // Call child method manually based on selected tab
    // if (e === 2 && this.cetTaskPending) {
    //   this.cetTaskPending.getData();
    // }
    if (e === 1 && this.cetTaskAll) {
      this.cetTaskAll.getData();
    }
    if (e === 2 && this.cetSourcingNeeds) {
      // this.cetSourcingNeeds.getData();
    }
    if (e === 3 && this.cetComplianceSafety) {
      this.cetComplianceSafety.loadData();
    }
    if (e === 4 && this.cetOutsourcing) {
      this.cetOutsourcing.getData();
    }
    if (e === 5 && this.cetInquiry) {
      this.cetInquiry.getData();
    }
    if (e === 6 && this.vendorTequests) {
      this.vendorTequests.getData();
    }
    if (e === 7 && this.cetQuotations) {
      this.cetQuotations.getData();
    }
    if (e === 8 && this.cetInvoices) {
      this.cetInvoices.getData();
    }
    if (e === 9 && this.addvancePayments) {
      this.addvancePayments.getData();
    }


    // if (e === 10 && this.cetNotes) {

    // -- notes moved to index 10 when payments and invoices are enabled else keep it in 8
    // --make the change to UI html file also
    if (e === 10 && this.cetNotes) {

      this.cetNotes.getData();
    }
    }, 500);
  }

  onRedirect(e: any) {
    this.selectedTabIndex = e;
  }

  togglePanel(): void {
    this.panelActive = !this.panelActive;
  }

  @ViewChild('getPDFModalTitle') getPDFModalTitle!: TemplateRef<{}>;
  getEventPDfModalRef: any;


  // refreshEventData(): Promise<any> {
  //   return new Promise((resolve) => {
  //     this.vm.getEventById(this.event.id, 1, 1);

  //       const sub = this.eventModel.subscribe((updatedEvent) => {
  //       if (updatedEvent && updatedEvent.id === this.event.id) {
  //         this.event = updatedEvent;
  //         resolve(updatedEvent);
  //       }
  //     });
  //   });
  // }

  refreshEventData(): Promise<any> {
  return new Promise((resolve) => {
    // 1. Subscribe FIRST to listen for the upcoming API response.
    const sub = this.eventModel.pipe(
      skip(1), // IMPORTANT: Skips the current, stale value in the BehaviorSubject.
      take(1)  // IMPORTANT: Takes only the next value and then automatically unsubscribes.
    ).subscribe((updatedEvent) => {
      // This code now only runs AFTER the API call completes and a new value is emitted.
      this.event = updatedEvent;
      resolve(updatedEvent); // Resolve the promise with the fresh data.
    });

    // 2. THEN, trigger the API call that will cause the BehaviorSubject to emit.
    this.vm.getEventById(this.event.id, 1, 1);
  });
}

  async OpenPdfModal() {
    await this.refreshEventData();

    this.getEventPDfModalRef = this.modal.create({
      nzTitle: this.getPDFModalTitle,
      nzContent: GenerateEventPdfComponent,
      nzFooter: null,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: 'fullscreen-modal',
      nzStyle: {
        top: '0',
        padding: '0',
        margin: '0',
        bottom: '0',
        right: '0'
      },
      nzBodyStyle: {
        height: 'calc(100vh - 65px)',
        overflow: 'auto',
        background: '#fff',
        padding: '24px',
      },
      nzWidth: '100%',
      nzData: {
        eventData: this.event
      }
    });
  }

  // Helper methods for converting timing strings to ISO UTC strings
  private toIsoUtc(dt: string): string | null {
    // Robustly normalize to 'YYYY-MM-DDTHH:mm:ssZ'
    if (!dt || typeof dt !== 'string') return null;

    // Case 1: Already has a 'T' separator; normalize hours/minutes/seconds and timezone
    if (dt.includes('T')) {
      const m = dt.match(/^(\d{4}-\d{2}-\d{2})T(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?(Z|[+-]\d{2}:?\d{2})?$/);
      if (!m) return null;
      const d = m[1];
      const h = m[2];
      const min = m[3];
      const s = m[4] ?? '00';
      const tz = m[5] ?? 'Z';
      const hh = h.padStart(2, '0');
      const mm = min.padStart(2, '0');
      const ss = s.padStart(2, '0');
      return `${d}T${hh}:${mm}:${ss}${tz}`;
    }

    // Case 2: Space-separated 'YYYY-MM-DD HH:mm[:ss]'
    const m2 = dt.trim().match(/^(\d{4}-\d{2}-\d{2})\s+(\d{1,2}):(\d{1,2})(?::(\d{1,2}))?$/);
    if (!m2) return null;
    const d = m2[1];
    const h = m2[2];
    const min = m2[3];
    const s = m2[4] ?? '00';
    const hh = h.padStart(2, '0');
    const mm = min.padStart(2, '0');
    const ss = s.padStart(2, '0');
    return `${d}T${hh}:${mm}:${ss}Z`;
  }

  private toMidnightIsoUtcFromIsoString(iso: string | null): string | null {
    if (!iso) return null;
    const date = iso.split('T')[0];
    return `${date}T00:00:00Z`;
  }
}
